import React from 'react'
import { Typography, AppBar } from '@mui/material'
import {makeStyles} from '@mui/styles'
import VideoPlayer from './components/VideoPlayer'
import Notifications from './components/Notifications'
import Options from './components/Options'

const useStyles = makeStyles((theme) => ({
    appBar: {
      borderRadius: 15,
      margin: '30px 100px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      width: '600px',
      border: '2px solid black',

    },
    image: {
      marginLeft: '15px',
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
  }));

const App = () => {
    const classes = useStyles();
  return (
    <div className={classes.wrapper}>
        
        <AppBar position='static' color='inherit' className={classes.appBar}>
            <Typography variant = "h2" align='center'>Video Chat</Typography>
        </AppBar>
    


        <VideoPlayer/>

        <Options>
            <Notifications/>
        </Options>

    </div>
  )
}

export default App